var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 50,
    viewBox: "0 0 206 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_202_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.7422 12.85H81.5852C83.8443 12.85 85.5055 13.3666 86.5686 14.3944C87.6318 15.4222 88.1633 16.9944 88.1633 19.1C88.1633 20.4889 87.8643 21.6166 87.2608 22.4833C86.6628 23.35 85.9208 23.9611 85.0459 24.3055C86.9119 24.8166 88.1855 26.0666 88.85 28.0555C89.0825 28.7722 89.1988 29.6055 89.1988 30.5555C89.1988 32.8222 88.6672 34.4889 87.6041 35.5555C86.5409 36.6222 84.8798 37.15 82.6206 37.15H67.7422V12.85ZM81.934 19.7944C81.934 18.4055 81.2419 17.7111 79.8576 17.7111H73.9715V22.5722H79.8576C81.2419 22.5722 81.934 21.8778 81.934 20.4889V19.7944ZM82.9695 29.5166C82.9695 28.1278 82.2773 27.4333 80.893 27.4333H73.9715V32.2944H80.893C82.2773 32.2944 82.9695 31.6 82.9695 30.2111V29.5166Z",
    fill: "#773030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.829 23.7834C100.378 23.7834 98.8776 24.1278 97.3272 24.8278V37.1556H91.2695V18.75H96.6351L96.9839 21.0056C98.9662 19.2722 101.043 18.4 103.213 18.4H104.769V23.7834H101.829Z",
    fill: "#773030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.498 31.9444C124.498 33.6833 124.005 35.0388 123.025 36.0222C122.045 37.0055 120.689 37.5 118.961 37.5H110.999C109.271 37.5 107.914 37.0111 106.934 36.0222C105.954 35.0388 105.461 33.6777 105.461 31.9444V23.9611C105.461 22.2222 105.949 20.8666 106.934 19.8833C107.914 18.9 109.271 18.4055 110.999 18.4055H118.961C120.689 18.4055 122.045 18.9 123.025 19.8833C124.005 20.8666 124.498 22.2277 124.498 23.9611V31.9444ZM118.441 24.4777C118.441 23.55 117.981 23.0889 117.056 23.0889H112.903C111.979 23.0889 111.519 23.55 111.519 24.4777V31.4222C111.519 32.35 111.979 32.8111 112.903 32.8111H117.056C117.981 32.8111 118.441 32.35 118.441 31.4222V24.4777Z",
    fill: "#773030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.955 29.8611L149.072 18.75H155.645L149.936 37.1556H143.535L140.074 26.0444L136.614 37.1556H130.213L124.504 18.75H131.082L134.194 29.8611L137.311 18.75H142.849L145.966 29.8611H145.955Z",
    fill: "#773030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.548 23.4388C165.324 23.4388 163.94 23.6722 162.395 24.1333V37.1555H156.337V18.75H161.703L162.052 20.4889C163.137 19.7722 164.25 19.2444 165.391 18.9111C166.531 18.5777 167.495 18.4055 168.281 18.4055H169.837C171.404 18.4055 172.661 18.8777 173.608 19.8277C174.555 20.7777 175.025 22.0389 175.025 23.6111V37.15H168.968V24.65C168.968 24.3055 168.851 24.0111 168.619 23.7833C168.386 23.55 168.098 23.4333 167.755 23.4333H166.542L166.548 23.4388Z",
    fill: "#773030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.023 37.1555H177.794V12.85H197.002V17.7111H184.023V23.4389H194.234V28.3H184.023V37.1555Z",
    fill: "#773030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206 19.4444V37.15H199.943V24.1278H197.346V19.4389H206V19.4444ZM199.943 12.5H206V17.3611H199.943V12.5Z",
    fill: "#773030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5354 25.1278V35.0778L23.0347 40.0111V50L46.4127 39.7945V29.5L34.5354 25.1278Z",
    fill: "#773030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4182 9.94444V20.2389L11.5395 34.2667V44.9389L0 40.1389V9.68889L23.0347 0L34.7237 4.97222L11.5838 15.2667V25.1278L34.7237 15.0056V4.97222L46.4182 9.94444Z",
    fill: "#773030"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.93e928bdb076150ccf98571bf8cba138.svg";
export { ForwardRef as ReactComponent };